export const PageText = {
  _1: 'Press Kit',
  _2: 'You can find the latest content on aircheckr here. If you still miss something, please <a href="/contact">contact us</a>.'
};

export const Categories = {
  _1: {
    title: 'aircheckr',
    subcategories: [
      {
        key: 0,
        text: 'Air pollution causes 467.000 deaths in Europe each year. Once a silent and underestimated killer, it is now recognized as the single biggest environmental health risk. But there is hope. Scientific research has shown that reducing your exposure to air pollution is effectively helping. But how to do that? aircheckr provides detailed outside air quality information and tools needed to effectively reduce your exposure. It empowers people to actively or passively make better decisions and take actions in order to breathe better air. People are no longer defenceless. Improving the air at home/office or car, or reducing your exposure during biking or exercising is now possible. Together with its partners, aircheckr is working hard to integrate air quality information into a wide range of services, applications or devices.'
      }
    ]
  },
  _2: {
    title: 'The problem of air quality',
    subcategories: [
      {
        key: 0,
        text: 'The effects of air pollution are alarming, mainly affecting the respiratory & cardiovascular system. In Belgium alone, every hour at least one person, on average, dies due to air pollution. Many people are concerned, but feel helpless to act accordingly. When you drink and drive and you have a car accident, it is quite clear what the cause is, but with air pollution this is not so straightforward. Air quality is very complex. There are many different pollutants and their effect on health is not always clear. Moreover, air quality varies a lot in time and space. The air pollution next to a highway at rush hour can strongly differ from these in the park 200 meters away.'
      }
    ]
  },
  _3: {
    title: 'Good AQ starts with good AQ data',
    subcategories: [
      {
        key: 0,
        text: 'The air quality data available today are mostly not suitable for personal use or implementation into a business context. aircheckr changes this completely with its real-time air quality information. The aircheckr algorithms calculate the air quality information at different levels of detail: real-time, forecasting or statistics. The European Air Quality Index translates the complex set of pollutant concentrations into a health-based and easy to understand number. Personal recommendation and hints allow people to take adequate actions if needed. The air quality data can easily be integrated in different applications through an extensive API and widgets.',
        text_2: 'aircheckr is made to impact our daily decisions, truly improving health of all.'
      }
    ]
  },
  _4: {
    title: 'Team',
    subcategories: [
      {
        key: 0,
        text: 'aircheckr is a product of <a href="https://www.nazka.be" target="_blank">Nazka Mapps</a> (www.nazka.be) and is supported by the European Space Agency. It is built by an enthusiastic, multidisciplinary team with experiences varying from location based services, full stack web development, environmental engineering and data science.'
      }
    ]
  },
  _5: {
    title: 'Logos',
    subcategories: [
      {
        key: 0,
        text: '<strong>You can download following logos:</strong>',
        logoBanners: [
          {
            key: 0,
            logoAlt: 'aircheckr logo horizontal',
            description: ''
          },
          {
            key: 1,
            logoAlt: 'aircheckr logo square',
            description: ''
          },
          {
            key: 2,
            logoAlt: 'aircheckr pictogramme',
            description: ''
          }
        ]
      }
    ]
  },
  _6: {
    title: 'Visuals & graphics',
    subcategories: [
      {
        key: 0,
        text: '<strong>Feel free to use one or several of the following visuals/graphics for your article:</strong>',
        logoBanners: [
          {
            key: 0,
            logoAlt: 'aircheckr team',
            description: ''
          },
          {
            key: 1,
            logoAlt: 'aircheckr founders',
            description: ''
          },
          {
            key: 2,
            logoAlt: 'aircheckr on mobile phone',
            description: ''
          },
          {
            key: 3,
            logoAlt: 'aircheckr widget',
            description: ''
          }
        ]
      }
    ]
  }
};

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/press-kit_page.js